<template>
    <div class="newfooter-style">
     
    
  
      <div class="footer-bottom">
        <div class="footer-bottomleft">
          <span class="bottomleft-logo">
<!--   
            <svg xmlns="http://www.w3.org/2000/svg" width="53" height="58" viewBox="0 0 53 58" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.6947 0.887695L0 13.141V45.0872L26.6947 57.7781L52.0765 45.0872V13.141L26.6947 0.887695ZM16.1922 21.0183L33.2593 12.2659L26.4171 9.64019L10.0655 17.9549L9.62793 40.7111L26.9729 49.4107L43.3245 40.7111V17.4134L26.4171 26.1475V33.7092L37.1978 28.4149V37.2699L26.4171 42.5143L15.7546 37.2699L16.1922 21.0183Z" fill="url(#paint0_linear_597_67)"/>
    <path opacity="0.3" d="M0 12.9053L26.2571 25.608V57.5424L0 44.8396V12.9053Z" fill="url(#paint1_linear_597_67)"/>
    <path opacity="0.2" d="M52.0767 12.917L26.2572 25.6079V57.5422L52.0767 44.8513V12.917Z" fill="url(#paint2_linear_597_67)"/>
    <defs>
      <linearGradient id="paint0_linear_597_67" x1="41.1361" y1="9.20244" x2="26.0382" y2="57.7781" gradientUnits="userSpaceOnUse">
        <stop stop-color="#02C7F6"/>
        <stop offset="1" stop-color="#0877FF"/>
      </linearGradient>
      <linearGradient id="paint1_linear_597_67" x1="13.1285" y1="12.9053" x2="13.1285" y2="43.5386" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset="1" stop-color="#030303" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint2_linear_597_67" x1="39.1669" y1="12.917" x2="39.1669" y2="43.5422" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset="1" stop-color="#030303" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg> -->
  <img src="../assets/image/homePage/mainbottom/logobottom.png" alt="">
            <!-- <span></span> -->
<!-- 
  <span class="bottomleftlogo-info">

     <span>成都北鸣</span>
      <span>B E I M I N G</span>
  </span> -->
  
  
          </span>
          <span class="bottomleftlogo-bottom">
            <span>成都北鸣电子科技有限公司</span>
            <span> 备案编号：蜀ICP备2023003901号</span>
       
          </span>
        </div>
        <div class="footer-content">
     
     <div id="amap-container" class="map-style"></div>
     <div>
       <div class="homefooter-right">
         <span>
   
           <svg
          
             xmlns="http://www.w3.org/2000/svg"
             width="16"
             height="12"
             viewBox="0 0 16 12"
             fill="none"
           >
             <mask id="path-1-inside-1_101_194" fill="white">
               <rect width="16" height="11.5556" rx="1" />
             </mask>
             <rect
               width="16"
               height="11.5556"
               rx="1"
               stroke="#999999"
               stroke-width="3"
               mask="url(#path-1-inside-1_101_194)"
             />
             <path
               d="M0.888672 1.77783L7.10536 4.88617C7.66841 5.1677 8.33116 5.1677 8.89421 4.88617L15.1109 1.77783"
               stroke="#999999"
               stroke-width="1.5"
             />
           </svg>
           <span class="righttext">官方邮箱</span></span
         >
         <span class="contactustext">business@graphchain.top</span>
       </div>
       <div class="homefooter-right">
         <span>
       
           <svg
           
             xmlns="http://www.w3.org/2000/svg"
             width="16"
             height="16"
             viewBox="0 0 16 16"
             fill="none"
           >
             <circle
               cx="8"
               cy="8"
               r="7.25"
               stroke="#999999"
               stroke-width="1.5"
             />
             <path
               d="M7.11133 3.55554V8.88888H11.5558"
               stroke="#999999"
               stroke-width="1.5"
             />
           </svg>
           <span class="righttext">工作时间</span></span
         >
         <span class="contactustext">周一至周五 9:30 - 18:30</span>
       </div>
       <div class="homefooter-right ">
         <span class="map-styleright"
           >
      
           <svg
      
            
             xmlns="http://www.w3.org/2000/svg"
             width="23"
             height="22"
             viewBox="0 0 23 22"
             fill="none"
           >
             <path
               d="M7.3124 6.27766C9.69673 4.14471 13.3033 4.14471 15.6876 6.27766C18.201 8.52608 18.4902 12.3581 16.3428 14.9583L11.5 20.8222L6.65719 14.9583C4.50977 12.3581 4.79901 8.52608 7.3124 6.27766Z"
               stroke="#999999"
               stroke-width="1.5"
             />
             <path
               d="M12.9442 11.0602C12.9442 11.8503 12.3037 12.4908 11.5136 12.4908C10.7235 12.4908 10.083 11.8503 10.083 11.0602C10.083 10.2701 10.7235 9.62964 11.5136 9.62964C12.3037 9.62964 12.9442 10.2701 12.9442 11.0602Z"
               fill="#999999"
             />
           </svg>
           公司总部
         </span>
         <span class="contactustextmap">
           成都市武侯区交子大道中海国际D座4-8楼</span
         >
       </div>
    
    
     </div>
   </div>
        <div class="footer-bottomright">
            <div>
            <b>微信公众号</b>
            <span class="footer-mainimage"
            >
        
  
         
            <img src="@/assets/image/homePage/mainbottom/wechat.png" alt="">
        
            </span>
          </div>
          <div>
            <b>客服微信</b>
            <span class="footer-mainimage"
            >
                <img src="@/assets/image/homePage/mainbottom/weixinimg.png" alt="" />
        
            </span>
          </div>
          <div>
            <b>成都北鸣</b>
            <span><router-link to="/product">产品服务</router-link></span>
            <span
              ><router-link to="/businessintroduce">业务介绍</router-link></span
            >
            <span> <router-link to="/aboutus">关于我们</router-link></span>
            <!-- <span>隐私政策</span> -->
          </div>
        
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ["name"],
    data() {
      return {
        connectionlist: {
          name: "",
          region: "",
          type: "",
        },
        isimage: false,
      };
    },
    mounted() {
      console.log(this.name);
      this.initAMap();
    },
    methods: {
      mouseoverbtn() {
        this.isimage = true;
      },
      mouseoutbtn() {
        this.isimage = false;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert("submit!");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      initAMap() {
        // 高德地图API加载完成后执行初始化
        this.$nextTick(() => {
          var map = new AMap.Map("amap-container", {
            zoom: 13, // 设置地图缩放级别
            center: [104.056544, 30.582004], // 设置地图中心点
          });
          //  navigator.geolocation.getCurrentPosition(
          // (position) => {
          //   console.log(position);
          // const latitude = position.coords.latitude;
          // const longitude = position.coords.longitude;
          // const currentPosition = [longitude, latitude];
          var marker = new AMap.Marker({
            position: [104.056544, 30.582004], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: "成都市武侯区交子大道中海国际D座4-8楼",
  
            label: {
              offset: new AMap.Pixel(30, 30), //修改label相对于maker的位置
              content: " 成都市武侯区交子大道中海国际D座4-8楼",
            },
          });
          map.add(marker);
          marker.on("click", function (e) {
            marker.markOnAMAP({
              name: " 成都市武侯区交子大道中海国际D座4-8楼",
              position: marker.getPosition(),
            });
          });
  
          // 移动地图中心到当前位置
          //   map.setCenter(currentPosition);
          // },
          //     (error) => {
          // if (error.code === error.PERMISSION_DENIED) {
          //   // 用户拒绝了地理位置权限
          //   alert("请授予地理位置权限以使用该功能。");
          // } else {
          //   // 其他错误，处理方式
          // }}
          //   );
  
          // 添加地图控件，如缩放控件
          // AMap.plugin(["AMap.ToolBar"], function () {
          //   var toolbar = new AMap.ToolBar();
          //   map.addControl(toolbar);
          // });
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "../assets/scss/newfooter.scss";
  </style>
  